import React, { useState, useEffect } from "react";
import { useStoreon } from "storeon/react";
import LiveScoringForm from "./liveScoringForm";
import styles from "./styles.module.scss";
import { useHistory } from "react-router-dom";
import { fetchBC } from "../../services/bowlingCenterService";
import {
  saveSettings,
  loadSettings,
  deleteSettings,
} from "../../services/setupService";
import { clean } from "../../shared/utils/cleanObject";
import { SET_SETUP_TYPE } from "../../store/setupType";
import CustomSelect from "../components/customSelect/customSelect";
import { success } from "../components/toast/toast";

const LiveScoringContainer = () => {
  const { dispatch, setupType, auth } = useStoreon("setupType", "auth");
  const [bowlingCentersInput, setBowlingCentersInput] = useState([]);
  const [bowlingCentersList, setBowlingCentersList] = useState([]);
  const [bowlingCentersSetting, setBowlingCentersSetting] = useState([]);
  const [errors, setErrors] = useState(null);
  // const [toggleMenu, setToggleMenu] = useState(false);
  const history = useHistory();

  useEffect(() => {
    fetchBC().then((data) => setBowlingCentersList(data));
  }, []);

  useEffect(() => {
    if (
      bowlingCentersList.length &&
      bowlingCentersSetting.length &&
      bowlingCentersSetting.length
    ) {
      const newData = bowlingCentersSetting.map((item, i) => {
        const bcIndex = bowlingCentersList.findIndex(
          (i) => i.uuid === item.uuid
        );

        return {
          uuid: item.uuid ? item.uuid : null,
          lane: item.lane ? item.lane : null,
          player: item.player ? item.player : "",
          playerNumber: item.playerNumber ? item.playerNumber : null,
          displayName: item.displayName ? item.displayName : "",
          bowlingCenterName:
            bcIndex > -1 ? bowlingCentersList[bcIndex].companyName : "",
          group: item.group ? item.group : null,
        };
      });

      const size = newData.length;
      const remainArray = size < 12 ? new Array(12 - size).fill(null) : [];

      setBowlingCentersInput([...newData, ...remainArray]);
    }
  }, [bowlingCentersList, bowlingCentersSetting, bowlingCentersSetting]);

  const loadBCSettings = () => {
    loadSettings(auth)
      .then((data) => {
        if (data.success === false && data.message === "Not Valid Token") {
          history.push("/login");
        }
        if (data && data.settings) {
          const newData = data.settings.map((item, i) => {
            return {
              uuid: item.bowlingcenter_uuid ? item.bowlingcenter_uuid : null,
              lane: item.lane_number ? item.lane_number : null,
              player: item.player_name ? item.player_name : "",
              playerNumber: item.player_number ? item.player_number : null,
              displayName: item.display_name ? item.display_name : "",
              bowlingCenterName: "",
              group: item.group ? item.group : null,
            };
          });

          setBowlingCentersSetting([...newData]);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    setBowlingCentersInput(new Array(12).fill(null));
  };

  useEffect(() => {
    loadBCSettings();
  }, []);

  const handleChange = (index, key) => (e) => {
    if (!bowlingCentersInput[index]) {
      bowlingCentersInput[index] = {
        uuid: null,
        player: "",
        lane: null,
        playerNumber: null,
        displayName: "",
        bowlingCenterName: "",
        group: null,
      };
    }
    bowlingCentersInput[index][key] = e.target.value;
    setBowlingCentersInput([...bowlingCentersInput]);
  };

  const handleChangeSetup = (id) => {
    dispatch(SET_SETUP_TYPE, id);
    if (id === "By Lane") {
      const res = bowlingCentersInput.map((b) => {
        return b
          ? {
              uuid: b.uuid,
              lane: b.lane,
              player: b.player ? b.player : "",
              playerNumber: b.playerNumber ? b.playerNumber : null,
              displayName: b.displayName ? b.displayName : "",
              bowlingCenterName: b.bowlingCenterName,
              group: b.group ? b.group : null,
            }
          : null;
      });
      setBowlingCentersInput(res);
    } else {
      const res = bowlingCentersInput.map((b) => {
        return b
          ? {
              uuid: b.uuid,
              lane: b.lane,
              player: b.player ? b.player : "",
              playerNumber: b.playerNumber ? b.playerNumber : null,
              displayName: b.displayName ? b.displayName : "",
              bowlingCenterName: b.bowlingCenterName,
              group: b.group ? b.group : null,
            }
          : null;
      });
      setBowlingCentersInput(res);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    localStorage.setItem(
      "bowlingCentersList",
      JSON.stringify(bowlingCentersInput)
    );
    history.push("/live-score-players");
  };

  const saveData = () => {
    const dataFiltered = bowlingCentersInput
      .filter((e) => e)
      .map((e) => {
        const row = {
          bowlingcenter_uuid: e.uuid,
          lane_number: +e.lane || null,
          player_number: +e.playerNumber || null,
          player_name: setupType === "By Lane" ? "" : e.player,
          display_name: setupType === "By Lane" ? "" : e.displayName,
          group: setupType === "By Lane" ? null : +e.group || null,
        };
        return clean(row);
      })
      .filter((e) => Object.keys(e).length);

    const data = {
      type: setupType === "By Lane" ? 1 : 2,
      data: dataFiltered,
    };
    saveSettings(auth, data).then((res) => {
      if (res.success === false) {
        if (
          res.message &&
          res.message[0] &&
          res.message[0] ===
            "player_name and player_number has values, remove one of them"
        ) {
          setErrors(res.message[0]);
        } else if (
          res.message &&
          res.message[0] &&
          res.message[0] ===
            "[0]: Key: 'SetupByPlayer.group' Error:Field validation for 'group' failed on the 'oneof' tag"
        ) {
          setErrors("Invalid group");
        } else {
          setErrors(
            setupType === "By Player"
              ? "Invalid data: bowling center, lane, group and display name fields are required"
              : "Invalid data: bowling center and lane fields are required"
          );
        }
      } else {
        setErrors(null);
        success("Data saved successfully", { onClose: () => {} });
        loadBCSettings();
      }
    });
  };

  const clearForm = () => {
    deleteSettings(auth).then((res) => {
      if (res.success === true) {
        setBowlingCentersInput(new Array(12).fill(null));
        success("Settings deleted successfully", { onClose: () => {} });
        loadBCSettings();
      }
    });
  };

  return (
    <div className={styles.overallContainer}>
      <div className={styles.bodyContainer}>
        <div className={styles.containerSetup}>
          <CustomSelect
            name="setupType"
            label={"Setup Type:"}
            options={[
              { value: "By Lane", valueDisplay: "By Lane" },
              { value: "By Player", valueDisplay: "By Player" },
            ]}
            value={setupType}
            horizontal
            onSelect={handleChangeSetup}
            classInput={styles.inputSelect}
          />
        </div>
        <LiveScoringForm
          data={bowlingCentersInput}
          bowlingCentersList={bowlingCentersList}
          errors={errors}
          setupType={setupType}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          saveData={saveData}
          clearForm={clearForm}
        />
      </div>
      <div className={styles.backgroundImage}></div>
      <div className={styles.backgroundImageFilter}></div>
    </div>
  );
};
export default LiveScoringContainer;
